import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

const ShowMoreCell = ({ moreCount, colSpan, onShowMore, tdClassName, showMoreCellSimplified }) => {
  if (moreCount <= 0) return null;
  return (
    <tr>
      <td className={cx('p-a-0 b-t', tdClassName)} colSpan={colSpan}>
        <button
          type="button"
          className={cx('btn btn-link d-block w-100 px-xs text-left', {
            'text-xxxs py-sm': !showMoreCellSimplified,
            'py-md': showMoreCellSimplified,
          })}
          onClick={(e) => {
            onShowMore(moreCount);
            e.currentTarget.blur();
          }}
        >
          <i
            className={cx('mr-xxxs', {
              'hicon-plus-circle': !showMoreCellSimplified,
              'hicon-angle-down text-lg v-a-m mb-xxs': showMoreCellSimplified,
            })}
          />
          <span>{showMoreCellSimplified ? 'Show more' : `Show (${moreCount}) more...`}</span>
        </button>
      </td>
    </tr>
  );
};

ShowMoreCell.propTypes = {
  colSpan: PropTypes.number.isRequired,
  moreCount: PropTypes.number.isRequired,
  onShowMore: PropTypes.func.isRequired,
  tdClassName: PropTypes.string,
  showMoreCellSimplified: PropTypes.bool,
};

export default ShowMoreCell;
